/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import * as EmailValidator from 'email-validator';
import { ERR_CLIENT_CONTACT_REQUIRED, ERR_CLIENT_NAME_REQUIRED, ERR_EMAIL, ERR_EMAIL_INVALID, LABEL_BTN_CANCEL, LABEL_BTN_SAVE, UNKNOWN_ERR } from 'src/constants/constant';
import { TextField, Typography, Divider, Autocomplete } from '@mui/material';
import type { ESPClientFormInputs, RootState } from '../../types/types';
import { useSelector } from 'react-redux';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import OutlineButton from '../../MUICustomButton/OutlineButton';
import GradientButton from '../../MUICustomButton/GradientButton';
import { useNavigate } from 'react-router-dom';

import { addClientData } from '../../../services/emailAPIClientServices';
import { getESPConnectionData } from 'src/services/emailAPIESPServices';


const validationSchema = Yup.object().shape({
    clientName: Yup.string().required(ERR_CLIENT_NAME_REQUIRED).matches(/^\S.*$/, "First character should not be a space"),
    clientContact: Yup.string().required(ERR_CLIENT_CONTACT_REQUIRED).matches(/^\S.*$/, "First character should not be a space"),
    email: Yup.string()
        .required(ERR_EMAIL)
        .email(ERR_EMAIL_INVALID)
        .test(
            'is-valid-email',
            ERR_EMAIL_INVALID,
            (value) => value === '' || EmailValidator.validate(value),
        ),
    espConnectionId: Yup.string().required("Please select email service provider"),
    
});


export interface PropsType {
    parentId?: string;
}

function AddClientForm({ parentId }: PropsType): JSX.Element {

    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [espConnectionData, setESPConnectionData] = useState<any>([])

    const { user } = useSelector((state: RootState) => state.auth);
    const navigate = useNavigate()
    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue
    } = useForm<ESPClientFormInputs>({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            clientName: '',
            clientContact: '',
            email: '',
        },
    });

    useEffect(() => {
        getESPConnectionData().then(
            (res: any) => {
                if(res.status === 200) {
                    if(res.data.result === 1) {
                        setESPConnectionData(res.data.data)
                    }
                }
            }
        )
        .catch(
            (error) => console.log(error)
        )
    }, [])

    const onSubmit = async (data: ESPClientFormInputs): Promise<void> => {
        setIsLoading(true)

        const requestParams = {
            "clientName": data.clientName,
            "email": data.email,
            "clientContact": data.clientContact,
            "createdBy": user?.id,
            "espConnectionId": data.espConnectionId,
        }

        try {
            const res = await addClientData(requestParams);

            if (res.status === 200) {
                if (res.data.result === 1) {
                    NotificationManager.success("Client created successfully");
                    setTimeout(() => {
                        if (parentId === undefined) {
                            handleBackClick()
                        } else {

                            navigate(-1)
                        }

                    }, 1000)
                } else {
                    const errorMsg: any = res.data.messages[0].message
                    NotificationManager.error(errorMsg.includes('Client name already exists') ? 'Client name already exists' : UNKNOWN_ERR, '', 5000);
                }
            }
        } catch (error) {
            console.error("Error occurred:", error);
            NotificationManager.error("Unknown error has occurred");
        } finally {
            setIsLoading(false);
        }
    }

    const handleBackClick = (): void => {
        navigate('/email-api/manage-clients')
    }

    return (
        <React.Fragment>
            <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '10px' }}>
                Profile
            </Typography>
            <Divider sx={{ color: '#D9D9D9', marginBottom: '10px' }} />
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    void handleSubmit(onSubmit)(e);
                }}
            >
                <div className='form-sub-container'>
                    <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '20px' }}>
                        Client Information
                    </Typography>
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="clientName"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <div>
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label={parentId !== undefined ? "Sub-client name*" : "Client name*"}
                                                autoComplete="off"
                                                placeholder={parentId !== undefined ? "Sub-client name*" : "Client name*"}

                                                error={Boolean(errors.clientName)}
                                            />
                                            {errors.clientName && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.clientName.message}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="clientContact"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <div>
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label={parentId !== undefined ? "Sub-client contact*" : "Client contact*"}
                                                autoComplete="off"
                                                placeholder={parentId !== undefined ? "Sub-client contact*" : "Client contact*"}

                                                error={Boolean(errors.clientContact)}
                                            />
                                            {errors.clientContact && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.clientContact.message}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='grid gap-5 grid-cols-2'>
                        <div className="w-full relative ">
                            <div className="mb-[30px]">
                                <Controller
                                    name="email"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <div>
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label="Email*"
                                                autoComplete="off"
                                                placeholder="Email*"

                                                error={Boolean(errors.email)}
                                            />
                                            {errors.email && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.email.message}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='form-sub-container'>
                    <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '20px' }}>
                        Email Configuration
                    </Typography>
                    
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="espConnectionId"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <div>
                                            <Autocomplete
                                                options={espConnectionData} // The list of clients
                                                getOptionLabel={(option: any) => option.connectionName} // Use clientName for display
                                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                //@ts-ignore
                                                isOptionEqualToValue={(option, value) => option.id === value} // Match by ID
                                                // value={clients.find((client) => client.id === field.value)} // Match current value
                                                onChange={(_, selectedConnection) => {
                                                    field.onChange(selectedConnection.id); // Update the form state
                                                    setValue("espDomainName", selectedConnection.domain)
                                                    setValue("fromEmailName", selectedConnection.fromName)
                                                    setValue("fromEmailAddress", selectedConnection.fromEmail)
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Email Service Provider*"
                                                        placeholder="Select Email Service Provider"
                                                        error={Boolean(errors.espConnectionId)}
                                                    />
                                                )}
                                                disableClearable // Prevent the clear button
                                            />
                                            {errors.espConnectionId && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.espConnectionId.message}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="w-full relative ">


                            <div className="mb-[30px]">
                                <Controller
                                    name="espDomainName"
                                    control={control}
                                    defaultValue=''
                                    render={({ field }) => (
                                        <div>
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label="Domain Name"
                                                autoComplete="off"
                                                placeholder="Domain Name"
                                                disabled

                                                error={Boolean(errors.espDomainName)}
                                            />
                                            {errors.espDomainName && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.espDomainName.message}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="fromEmailName"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <div>
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label={"From Email Name"}
                                                autoComplete="off"
                                                placeholder={"From Email Name"}
                                                disabled

                                                error={Boolean(errors.fromEmailName)}
                                            />
                                            {errors.fromEmailName && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.fromEmailName.message}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="w-full relative ">
                            <div className="mb-[30px]">
                                <Controller
                                    name="fromEmailAddress"
                                    defaultValue=""
                                    control={control}
                                    render={({ field }) => (
                                        <div>
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label="From Email Address"
                                                autoComplete="off"
                                                placeholder="From Email Address"
                                                disabled

                                                error={Boolean(errors.fromEmailAddress)}
                                            />
                                            {errors.fromEmailAddress && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.fromEmailAddress.message}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='flex gap-2 justify-end mt-[30px]'>
                    <OutlineButton color='gray' onClick={() => handleBackClick()} width='130px'>{LABEL_BTN_CANCEL}</OutlineButton>
                    <GradientButton type='submit' color='red' onClick={handleBackClick} width='130px'>{!isLoading ? LABEL_BTN_SAVE : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                </div>
            </form>
        </React.Fragment>
    )
}

export default AddClientForm